import { defineComponent, ref, h } from 'vue';
import { Doughnut } from 'vue-chartjs';
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  ArcElement
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

// Register required components for the doughnut chart
ChartJS.register(Tooltip, Legend, ArcElement, ChartDataLabels);

export default defineComponent({
  name: 'DoughnutChart',
  components: {
    Doughnut
  },
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  setup() {
    // Assuming props.chartData is used in the render function
    const options = ref({
      plugins: {
        legend: {
          position: 'top',
          padding: 25,
          labels: {
            font: {}
          }
        },
        datalabels: {
          color: '#fff',
          anchor: 'end',
          align: 'start',
          formatter: (value) => `${value}%`,
          font: {
            weight: 'bold',
            size: 20
          },
          display: (context) => {
            const value = context.dataset.data[context.dataIndex];
            return value > 1; // Show label only if the value is greater than 1%
          }
        }
      },
      responsive: true,
      maintainAspectRatio: false
    });

    return {
      options
    };
  },
  render() {
    // Access props.chartData directly here
    return h('div', { style: { height: '500px' } }, [
      h(Doughnut, {
        data: this.chartData,  // Accessing chartData directly in the render function
        options: this.options
      })
    ]);
  }
});
